.searchContainer {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.formButton {
  background-color: var(--bloom-colors-store-button);
  border-color: var(--bloom-colors-store-button);
  height: 60px;
  color: var(--bloom-colors-header-contrast-text-label);

  &[data-selected='true'] {
    border-color: var(--bloom-colors-header-contrast-text-label);
  }
}

[id='store-type-tabs'] .formTabSelected {
  border-bottom: 2px solid var(--bloom-colors-header-contrast-text-label);
  box-shadow: none;

  span {
    color: var(--bloom-colors-header-contrast-text-label);
  }
}

[id='store-type-tabs'] .formTab {
  border-bottom: 1px solid var(--colors-grays-light);
  box-shadow: none;

  span {
    color: var(--bloom-colors-header-contrast-text-label);
  }
}

.formButton--disabled {
  opacity: 0.4;
}

.closeContainer {
  position: absolute;
  right: 0;
  bottom: 0;
  padding: 16px;
  width: 100%;
  background-color: var(--bloom-colors-header-contrast);
  z-index: 2;
}

.form {
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 24px;
}

.form--withAddresses {
  height: 100%;
}

.unavailableError {
  margin: 0 16px;
}

@media all and (--reefer-media-tablet-min) {
  .form {
    padding: 0;
  }

  .formButton {
    height: 68px;
  }

  .unavailableError {
    margin: 0;
  }
}
